import React, { useState, useEffect, memo } from 'react';
import { Box, Typography, Container } from '@mui/material';
import WallpaperVideo from '../assets/home-tree.mp4';

const Corporate_identity = memo(() => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Container
      maxWidth={false}
      disableGutters
      sx={{
        position: 'relative',
        width: "100%",
        height: "100vh",
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        overflow: 'hidden',
      }}
    >
      <Box
        component="video"
        autoPlay
        loop
        muted
        playsInline
        src={WallpaperVideo}
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          zIndex: -1,
        }}
      />

      {/* 左側のテキストエリア */}
      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          opacity: isVisible ? 1 : 0,
          transition: "opacity 1s ease-in",
          textAlign: { xs: "center", md: "left" },
          color: 'white',
          
          // 👈 【修正ポイント】スマホ(xs)では背景色を透明に、PC(md)では透過白に
          backgroundColor: { xs: 'transparent', md: 'rgba(255, 255, 255, 0.2)' },
          
          // 👈 【修正ポイント】スマホ(xs)ではぼかしを解除(none)、PC(md)ではぼかしを適用
          backdropFilter: { xs: 'none', md: 'blur(10px)' },
          
          padding: { xs: 2, md: 8 },
          height: "100%",
          zIndex: 1,
          marginTop: { xs: "64px", md: 0 },
        }}
      >
        <Typography 
          variant="h3" 
          sx={{ 
            marginLeft: { xs: 0, md: '15px' }, 
            fontWeight: 'bold', 
            fontFamily: "'Noto Serif JP', serif",
            fontSize: { xs: "24px", sm: "32px", md: "48px" },
            lineHeight: 1.5,
            // スマホ時は背景がなくなる分、影(textShadow)を少し強めにしておくと読みやすくなります
            textShadow: '0px 2px 15px rgba(0,0,0,0.5)', 
          }}
        >
          あなたの物語を次の時代へ
        </Typography>
      </Box>

      <Box
        sx={{
          flex: 1,
          display: { xs: "none", md: "flex" },
        }}
      />
    </Container>
  );
});

export default Corporate_identity;
